export const SERVER_ERROR_INCORRECT_PASSWORD = "The current password is incorrect."
